import { render } from "./ProviderAddData.vue?vue&type=template&id=54d292d4"
import script from "./ProviderAddData.vue?vue&type=script&lang=js"
export * from "./ProviderAddData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__